import { getOwnerRpc, getOwnedMerchandiseRpc } from 'growth-monetization-service-types';
import { rpcClient } from '../client';
export const fetchOwners = () => rpcClient.call(getOwnerRpc, {});
export const fetchOwnedMerchandise = () => rpcClient.call(getOwnedMerchandiseRpc, {});